import { format } from 'date-fns/format';
import { sha256 } from 'hash.js';
import seedrandom from 'seedrandom';

import { adjustedStartOfDay } from './adjusted-time';
import type { SpacedRepetitionConfig } from './types';

function generateHash(str: string): string {
  return sha256().update(str).digest('hex');
}

/** Deterministic [0,1) value for id + adjusted calendar day + seed (used for fuzz and card shuffle). */
export function getRandomNumberForId(
  id: string,
  date: Date,
  cutoffTime: SpacedRepetitionConfig['cutoffTime'],
  seed: number = 0,
): number {
  return randomNumberForIdOnDay(id, adjustedDayKey(date, cutoffTime), seed);
}

/** The adjusted calendar day {@link getRandomNumberForId} keys on. */
export function adjustedDayKey(
  date: Date,
  cutoffTime: SpacedRepetitionConfig['cutoffTime'],
): string {
  return format(adjustedStartOfDay(date, cutoffTime), 'yyyy-MM-dd');
}

/** {@link getRandomNumberForId} with the day already resolved by {@link adjustedDayKey}. */
export function randomNumberForIdOnDay(id: string, dayKey: string, seed: number = 0) {
  const hash = generateHash(`${id}_${dayKey}_${seed}`);
  const rng = seedrandom(hash);
  return rng();
}

export function fuzzyReviewInterval(
  reviewIntervalDays: number,
  cardId: string,
  reviewDate: Date,
  spacedRepetitionConfig: SpacedRepetitionConfig,
): number {
  const fuzzFactor = spacedRepetitionConfig.fuzzFactor;
  const fixedRandomForIdDate = getRandomNumberForId(
    cardId,
    reviewDate,
    spacedRepetitionConfig.cutoffTime,
  );
  const fuzz = fuzzFactor * 2 * fixedRandomForIdDate - fuzzFactor;
  return Math.round(reviewIntervalDays * (1.0 + fuzz));
}
